/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-unresolved */
import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector, useDispatch } from 'react-redux';

import { selectDelivery, selectOrder } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { updateChange } from '@/store/slices/order';

interface PaymentObject {
  [key: string]: number;
}

const Change = () => {
  const dispatch = useDispatch();
  const { total: totalCost } = useSelector(selectOrder);
  const { data: profile } = useFetchPosProfileDetails();
  const { delivery } = useSelector(selectDelivery);

  const total = totalCost + (delivery?.delivery_amount || 0);

  const { values } = useFormikContext<any>();

  const filteredObject = Object.keys(values).reduce<PaymentObject>(
    (obj, key) => {
      if (key !== 'loyalty_points') {
        obj[key] = values[key];
      }
      return obj;
    },
    {},
  );

  const objectValues: number[] = Object.values(filteredObject);

  const totalAmount = objectValues.reduce(
    (curr: number, total: number): number => curr + total,
    0,
  );

  const amountToBePaid = total;

  let amountLeft =
    totalAmount - amountToBePaid - (delivery?.delivery_amount || 0);

  if (amountLeft <= 0) {
    amountLeft = 0;
  }

  dispatch(updateChange(amountLeft));

  return (
    <Typography
      sx={{
        fontWeight: '400',
        fontFamily: 'Montserrat',
        fontSize: '13px',

        '& span': {
          ml: 1,
          mt: 4,
        },
      }}
    >
      Change:
      <span>
        {profile?.currency}
        {amountLeft.toLocaleString('en-US')}
      </span>
    </Typography>
  );
};

export default Change;
